import React, { Component } from "react";
import Theme from "../../assets/Theme";
import style from "../../config/style.json";
import { Container, Grid } from "@mui/material";
import Background from "../../assets/images/home-login.jpg";
import Logo from "../../assets/images/logo-white.png";
import { Outlet } from "react-router-dom";
import { ENV } from "../../config/config.js"

export default class MainLogin extends Component {
  constructor(props) {
    super(props);
    this.environmentIdentifier = ENV;
    this.state = {
      hash: "",
      statesLogin: {
        login: true,
        forgot: false,
        reset: false,
      },
    };
  }

  render() {
    return (
      <Theme>
        <div
          styles={style}
          className={
            this.environmentIdentifier === "andy"
              ? `environmentAndy`
              : `environmentProduction`
          }>
          <main className="main login">
            <Container disableGutters maxWidth={false} sx={{ height: "100vh" }}>
              <Grid container sx={{ height: "100%" }}>
                {/* Usamos Grid para la visibilidad y el tamaño */}
                <Grid item md={4} sx={{ display: { xs: "none", sm: "block" } }}>
                  <div
                    className="bg-login h-100 align-items-center"
                    style={{
                      backgroundImage: `url(${Background})`,
                      height: "100%",
                    }}
                  >
                    <img
                      className="logo mx-auto"
                      src={Logo}
                      alt="Travel Curious"
                      style={{ maxWidth: "60%", margin: "0px auto" }}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  md={8}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Outlet />
                </Grid>
              </Grid>
            </Container>
          </main>
        </div>
      </Theme>
    );
  }
}
